import { fetchAuthSession } from 'aws-amplify/auth'

const getBaseUrl = () => process.env.REACT_APP_API_URL

async function authHeaders() {
  const { tokens } = await fetchAuthSession()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokens.idToken.toString()}`,
  }
}

export const api = {
  async getCharities() {
    const res = await fetch(`${getBaseUrl()}/charities`)
    if (!res.ok) throw new Error('Failed to fetch charities')
    return res.json()
  },

  async getAdminCharities() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/charities?include_inactive=true`, { headers })
    if (!res.ok) throw new Error('Failed to fetch charities')
    return res.json()
  },

  async postCharity(url) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/charities`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ url }),
    })
    if (!res.ok) throw new Error('Failed to add charity')
    return res.json()
  },

  async putCharity(id, data) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/charities/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to update charity')
    return res.json()
  },

  async deleteCharity(id) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/charities/${id}`, {
      method: 'DELETE',
      headers,
    })
    if (!res.ok) throw new Error('Failed to delete charity')
  },

  async getJob(jobId) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/jobs/${jobId}`, { headers })
    if (!res.ok) throw new Error('Failed to fetch job status')
    return res.json()
  },
}
